import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import {
  Component,
  ElementRef,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import {
  NgbModal,
  NgbModalConfig,
  NgbOffcanvas,
} from "@ng-bootstrap/ng-bootstrap";
import { NgbModalRef } from "@ng-bootstrap/ng-bootstrap/modal/modal-ref";
import { Store } from "@ngrx/store";
import moment from "moment";
import { BaseChartDirective } from "ng2-charts";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { forkJoin } from "rxjs";
import { breadcrumbItem } from "src/app/components/breadcrumbs/breadcrumbs.model";
import { TranslatePipe } from "src/app/core/pipes/translate.pipe";
import { AlertService } from "src/app/core/services/AlertService/alert.service";
import { AppAliasService } from "src/app/core/services/app-alias.service";
import { locationBroadcastService } from "src/app/core/services/loaction-broadcast.service";
import { API2 } from "src/app/core/services/server-api.service";
import { ApiService } from "src/app/services/api";
import { BreadcrumbService } from "src/app/services/breadcrumb";
import { AppState } from "src/app/store/app.state";
import { setLoadingSpinner } from "src/app/store/sharedstate/shared.actions";
import { TimezoneService } from "./../../../../services/timezone";

@Component({
  selector: "app-payroll",
  templateUrl: "./payroll.component.html",
  styleUrls: ["./payroll.component.scss"],
  providers: [API2.Main, ToastrService, NgbModalConfig, NgbModal, TranslatePipe],
})
export class PayrollComponent implements OnInit {
  breadcrumbItems: breadcrumbItem[] = [
    {
      label: "Home",
      active: false,
      url: "/home",
    },
    {
      label: "Analytics and Reports",
      active: false,
      url: "/reports/sales/gross-transaction/report-home",
    },
    {
      label: "Labor /",
      active: true,
      url: "/reports/labor/cashout",
    },
    {
      label: "Payroll",
      active: true,
      url: "",
    },
  ];

  isLoading = false;
  subForm: FormGroup;
  emailForm: FormGroup;
  subFormSubmitted = false;
  submitEmail = false;
  page = 1;
  active = 2;
  itemsPP: any = 1000;
  employeeError: boolean = false;

  @Input() esClient: any;
  @ViewChild("exportselect") exportselect: ElementRef;
  @ViewChild("modal") modal: ElementRef;
  subscribeEmailModal: NgbModalRef;

  @ViewChild(BaseChartDirective) timeline;
  httpOptions2 = {};
  // For datepicker
  public daterange: any = {};
  startDate: any = this.timezoneService.get()().startOf("day");
  endDate: any = this.timezoneService.get()().endOf("day");
  startDateDisplay: any = this.startDate.format("MMM Do YYYY");
  endDateDisplay: any = this.endDate.format("MMM Do  HH:mm");
  current_start_date = this.startDate.format("MM/DD/YYYY");
  current_end_date = this.endDate.format("MM/DD/YYYY");
  current_date = this.timezoneService.get()().format("MM/DD/YYYY");
  current_time = this.timezoneService.get()().format("h:mm:ss a");
  startDateUnix: Number = this.startDate.unix();
  endDateUnix: Number = this.endDate.unix();
  dropdownSettings = {};
  listOfemployees: any;
  revenuesDropdownSettings;


  scheduleEmployee: any
  frequency: any = []
  freqList: any
  freqdropdownSettings: any = {};

  options: any = {
    locale: { format: "YYYY-MM-DD" },
    startDate: this.timezoneService.get()().startOf("day"),
    endDate: this.timezoneService.get()().endOf("day"),
    alwaysShowCalendars: true,
    ranges: {
      Today: [this.timezoneService.get()(), this.timezoneService.get()()],
      Yesterday: [
        this.timezoneService.get()().subtract(1, "days"),
        this.timezoneService.get()().subtract(1, "days"),
      ],
      "Last 7 Days": [
        this.timezoneService.get()().subtract(6, "days"),
        this.timezoneService.get()(),
      ],
      "Last 30 Days": [
        this.timezoneService.get()().subtract(29, "days"),
        this.timezoneService.get()(),
      ],
      "This Month": [
        this.timezoneService.get()().startOf("month"),
        this.timezoneService.get()().endOf("month"),
      ],
      "Last Month": [
        this.timezoneService.get()().subtract(1, "month").startOf("month"),
        this.timezoneService.get()().subtract(1, "month").endOf("month"),
      ],
    },
  };
  GLOBALURL: any;
  multiselectControl = new FormControl(null, Validators.required);
  constructor(
    private translatePipe: TranslatePipe,
    public http: HttpClient,
    public cookieService: CookieService,
    public router: Router,
    private toastr: AlertService,
    private locService: locationBroadcastService,
    public main: API2.Main,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private store: Store<AppState>,
    private ApiService: ApiService,
    private BreadcrumbService: BreadcrumbService,
    private offcanvasService: NgbOffcanvas,
    private timezoneService: TimezoneService,
    private AppAliasService: AppAliasService
  ) {
    this.GLOBALURL = this.ApiService.getBaseURL();
  }
  //location service check if load data
  isLoadData = false;
  ngOnInit() {
    this.BreadcrumbService.setValue(this.breadcrumbItems);
    this.AppAliasService.getStoreValue().subscribe((res) => {
      if (res === '*') {
        this.toastr.error('Please select a store');
        return;
      }
    }
    );
    this.storeId = this.cookieService.get("storeId");
        if (!this.storeId || this.storeId === '*') {
          this.toastr.error('Please select a store');
          return;
        }
    if (!Boolean(this.currency)) {
      this.currency = "$";
    }
        this.freqList = [
      { value: 0, text :"DAILY"},
      { value: 1, text :"WEEKLY"},
      { value: 2, text :"MONTHLY"},
    ]

    this.subForm = new FormGroup({
      multiselect: this.multiselectControl,
    });
    this.emailForm = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
      emailCC: ["", [Validators.email]],
    });

    if (this.storeId != "*") {
      this.params = this.params.set("storeId", this.storeId);
      this.httpOptions = { headers: new HttpHeaders(this.headerToken) };
      this.httpOptions2 = {
        headers: new HttpHeaders(this.headerToken),
        params: this.params,
      };
    } else {
      this.httpOptions = { headers: new HttpHeaders(this.headerToken) };
      this.httpOptions2 = { headers: new HttpHeaders(this.headerToken) };
    }
    // this.currency =
    //   localStorage.getItem("currency") === null ||
    //   localStorage.getItem("currency") === "undefined"
    //     ? "$"
    //     : localStorage.getItem("currency");

    if (!this.isLoadData) {
      this.fetchEmployee();
    }

    this.getSettings();
    this.dropdownSettings = {
      singleSelection: false,
      idField: "id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: "ShowFilter",
    };
    this.revenuesDropdownSettings = {
      singleSelection: false,
      idField: "revenueCenterId",
      textField: "revenueCenterName",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: "ShowFilter",
    };
    this.freqdropdownSettings = {
      singleSelection: false,
      closeDropDownOnSelection: true,
      idField: "value",
      textField: "text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: "ShowFilter",
    };
    forkJoin([
      this.translatePipe.transform("Select All"),
      this.translatePipe.transform("UnSelect All"),
      this.translatePipe.transform("Search"),
    ]).subscribe(([selectAll, unselectAll, search]) => {
      this.freqdropdownSettings.selectAllText = selectAll;
      this.freqdropdownSettings.unSelectAllText = unselectAll;
      this.freqdropdownSettings.searchPlaceholderText = search;
    })

    forkJoin([
      this.translatePipe.transform("Select All"),
      this.translatePipe.transform("UnSelect All"),
      this.translatePipe.transform("Search"),
    ]).subscribe(res => {
        this.dropdownSettings = {
          singleSelection: false,
          idField: "id",
          textField: "name",
          selectAllText: res[0],
          unSelectAllText: res[1],
          itemsShowLimit: 1,
          allowSearchFilter: "ShowFilter",
          searchPlaceholderText: res[2]
        };
        this.revenuesDropdownSettings = {
          singleSelection: false,
          idField: "revenueCenterId",
          textField: "revenueCenterName",
          selectAllText: res[0],
          unSelectAllText: res[1],
          itemsShowLimit: 1,
          allowSearchFilter: "ShowFilter",
          searchPlaceholderText: res[2]
        };
      },
      (error) => {})
  }

  companyName: string = "";

  getBase64Image(img) {
    const canvas = document.createElement("canvas");

    canvas.width = 150;
    canvas.height = 150;
    const ctx = canvas.getContext("2d");
    try {
      ctx.drawImage(img, 0, 0);
      const dataURL = canvas.toDataURL("image/png");
      return dataURL;
    } catch (err) {
      return "No";
    }
  }
  get f(): { [key: string]: AbstractControl } {
    return this.subForm.controls;
  }

  newBiggerRevenueCenters = [];

  sortByName(arr, attr, order) {
    if (order) {
      order = false;
    } else {
      order = true;
    }
    return arr.sort((first, second) => {
      if (first[attr].toUpperCase() > second[attr].toUpperCase()) {
        if (order) {
          return 1;
        } else {
          return -1;
        }
      } else if (first[attr].toUpperCase() < second[attr].toUpperCase()) {
        if (order) {
          return -1;
        } else {
          return 1;
        }
      }
    });
  }

  reformat(str, type) {
    if (type == 0) {
      if (!str.includes("P/O")) {
        return "P/O " + str;
      } else {
        return str;
      }
    } else {
      if (!str.includes("P/I")) {
        return "P/I " + str;
      } else {
        return str;
      }
    }
  }

  timeZone = this.cookieService.get("timezone");

  // Locations
  locations: any = JSON.parse(localStorage.getItem("locations"));
  selectedLocation: any =
    this.cookieService.get("storeId") == "*"
      ? "*"
      : this.cookieService.get("storeId");
  show_selected_location =
    this.selectedLocation == "*" ? "All" : this.selectedLocation;
  current_location_name =
    // this.selectedLocation == "*"
    //   ? "All"
    //   : this.locations.filter(
    //       (location) => location.id == this.selectedLocation
    //     )[0].text;
    this.selectedLocation == "*"
  ? "All"
  : (this.locations?.filter((location) => location.id == this.selectedLocation).length > 0
    ? this.locations?.filter((location) => location.id == this.selectedLocation)[0].text
    : "Location not found");

  changeLocation(value: any) {
    this.storeId = value;
    this.loadPage();
    this.fetchEmployee();
    // this.fetchRevenue();
  }
  // Export
  exportchoices: any = [
    { id: "", text: "Export" },
    { id: "pdf", text: "Export to PDF" },
  ];
  exportChoice: any = "";

  business_logo: any = this.cookieService.get("logo")
    ? this.cookieService.get("logo")
    : "";

  public selectedDate(value: any, datepicker?: any) {
    if (value.picker != undefined || value.picker != undefined) {
      this.startDate = value.picker.startDate;
      this.endDate = value.picker.endDate;
    } else {
      this.startDate = value.start;
      this.endDate = value.end;
    }

    const hour = Number(this.startTime?.split(["."])[0]) || 0;
    const minutes = this.startTime?.split(["."])[1] || 0;

    this.startTimeFormatted = this.timezoneService
      .get()(this.startDate)
      .startOf("day")
      .add(hour, "hours")
      .add(minutes, "minutes")
      .format("HH:mm a");
    this.startDate = this.timezoneService
      .get()(this.startDate)
      .subtract(0, "days")
      .set({ hours: hour })
      .set({ minutes: minutes });

    const hourEnd = Number(this.endTime.split(["."])[0]) || 0;
    const minutesEnd = this.endTime.split(["."])[1] || 0;

    this.endTimeFormatted = this.timezoneService
      .get()(this.endDate)
      .startOf("day")
      .add("hour", hourEnd)
      .add("minutes", minutesEnd)
      .format("HH:mm a");
    //change subtract
    this.endDate = this.timezoneService
      .get()(this.endDate)
      .subtract(0, "days")
      .set({ hours: hourEnd })
      .set({ minutes: minutesEnd });

    this.startDateDisplay = this.startDate.format("MMM Do YYYY");
    this.endDateDisplay = this.endDate.format("MMM Do YYYY");
    this.current_start_date = this.startDate.format("MM/DD/YYYY");
    this.current_end_date = this.endDate.format("MM/DD/YYYY");

    this.setTimeStart();
    this.setTimeEnd();

    if (
      this.ClosingDay == "Next Day" &&
      this.startDateDisplay == this.endDateDisplay
    ) {
      window.alert(
        "Same start and end date cannot be selected with Next Day option."
      );
    } else {
      this.fetchRerport(
        this.timezoneService.get()(this.startDate).format("X"),
        this.timezoneService.get()(this.endDate).format("X")
      );
    }
  }

  setTimeStart(): void {
    this.timeStart = this.startTimeFormatted.includes("am") ?
      this.startTimeFormatted.replace("am", "").trim() : this.startTimeFormatted.replace("pm", "").trim();

    console.log("TIME START", this.timeStart);
  }

  setTimeEnd(): void {
    this.timeEnd = this.endTimeFormatted.includes("am") ?
      this.endTimeFormatted.replace("am", "").trim() : this.endTimeFormatted.replace("pm", "").trim();

    console.log("TIME END", this.timeEnd);
  }

  // For table
  rows = [];
  backuptabledata = [];
  taxes = [];
  userName = "";
  totalElements: any = [];
  pdfName = "";
  currency: any = this.cookieService.get("currency");

  logo = null;

  getDataUri(url, cb) {
    const image = new Image();
    image.setAttribute("crossOrigin", "anonymous"); //getting images from external domain

    image.onload = function () {
      const canvas = document.createElement("canvas");
      canvas.width = 150;
      canvas.height = 150;

      //next three lines for white background in case png has a transparent background
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "#fff"; /// set white fill style
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      canvas
        .getContext("2d")
        .drawImage(
          image,
          0,
          0,
          image.width,
          image.height,
          0,
          0,
          canvas.width,
          canvas.height
        );

      cb(canvas.toDataURL("image/jpeg"));
    };
    image.src = url;
  }

  changeStore(event: any) {
    // this.params = new HttpParams();
    // this.storeId = event;
    // this.cookieService.set('storeId', this.storeId, 70, '/');
    this.params = new HttpParams();
    this.storeId = event;
    if (event !== "*") {
      this.params = this.params.set("storeId", this.storeId);
      this.httpOptions = {
        headers: new HttpHeaders(this.headerToken),
        params: this.params,
      };
      this.fetchEmployee();
      this.loadPage();
      // this.fetchRevenue();
    } else {
      this.httpOptions = { headers: new HttpHeaders(this.headerToken) };
      this.fetchEmployee();
      this.loadPage();
      // this.fetchRevenue();
    }
  }
  ranges = {
    Today: [this.timezoneService.get()(), this.timezoneService.get()()],
    Yesterday: [
      this.timezoneService.get()().subtract(1, "days"),
      this.timezoneService.get()().subtract(1, "days"),
    ],
    "Last 7 Days": [
      this.timezoneService.get()().subtract(6, "days"),
      this.timezoneService.get()(),
    ],
    "Last 30 Days": [
      this.timezoneService.get()().subtract(29, "days"),
      this.timezoneService.get()(),
    ],
    "This Month": [
      this.timezoneService.get()().startOf("month"),
      this.timezoneService.get()().endOf("month"),
    ],
    "Last Month": [
      this.timezoneService.get()().subtract(1, "month").startOf("month"),
      this.timezoneService.get()().subtract(1, "month").endOf("month"),
    ],
  };

  timeStart: any = "00:00";
  timeEnd: any = "23:59";

  ClosingDay = "Same Day";

  boolean = false;
  startTime: any = "0";
  endTime: any = "23";
  startTimeFormatted = this.timezoneService
    .get()()
    .startOf("day")
    .format("HH:mm a");
  endTimeFormatted = this.timezoneService
    .get()()
    .endOf("day")
    .format("HH:mm a");
  dateTimeArray: any[] = [];

  getSettings() {
    this.store.dispatch(setLoadingSpinner({ status: true }));
    this.http.get(this.GLOBALURL + "/settings", this.httpOptions2).subscribe(
      (resp: any) => {
        // this.store.dispatch(setLoadingSpinner({ status: false }));
        if (resp.success === 0) {
          this.toastr.error(resp.message);
        } else {
          let StartOfHourByDay = resp.response.find(
            (el) => el.settingName === "StartOfHourByDay"
          );
          let EndOfHourByDay = resp.response.find(
            (el) => el.settingName === "EndOfHourByDay"
          );
          let ClosingDay = resp.response.find(
            (el) => el.settingName === "ClosingDay"
          );

          if (!StartOfHourByDay || !EndOfHourByDay || !ClosingDay) {
            this.setTimes(0, 0, 23, 30);
            StartOfHourByDay = "00:00";
            EndOfHourByDay = "23:59";
            ClosingDay = "Same Day";
          } else {
            StartOfHourByDay = StartOfHourByDay.settingValue;
            EndOfHourByDay = EndOfHourByDay.settingValue;
            ClosingDay = ClosingDay.settingValue;
          }

          this.ClosingDay = ClosingDay;
          let dateTimeToday = this.timezoneService.get()();

          const startHour = Number(StartOfHourByDay.split([":"])[0]);
          const startMinutes = Number(StartOfHourByDay.split([":"])[1]);
          this.startDate = this.timezoneService
            .get()(this.startDate)
            .set({ hours: startHour })
            .set({ minutes: startMinutes });
          this.startDateDisplay = this.timezoneService
            .get()(this.startDate)
            .format("MMM Do YYYY");

          let hour = 23;
          let minutes = 59;

          hour = Number(EndOfHourByDay.split([":"])[0]);
          minutes = Number(EndOfHourByDay.split([":"])[1]);
          this.endDate = this.timezoneService
            .get()(this.endDate)
            .set({ hours: hour })
            .set({ minutes });
          this.endDateDisplay = this.timezoneService
            .get()(this.endDate)
            .format("MMM Do YYYY");

          this.options.startDate = this.startDate;

          if (
            this.startDate.diff(dateTimeToday) > 0 &&
            this.endDate.diff(dateTimeToday) > 0
          ) {
            /**
             * Current time is before restaurant hours
             * Date set would be yesterday and today
             */
            this.startDate = this.timezoneService
              .get()(this.startDate)
              .subtract(1, "days");
            this.startDateDisplay = this.timezoneService
              .get()(this.startDate)
              .format("MMM Do YYYY");

            this.options.startDate = this.startDate;
          } else if (
            this.startDate.diff(dateTimeToday) > 0 &&
            this.endDate.diff(dateTimeToday) < 0
          ) {
            /**
             * Current time is after restaurant hours
             * Date set would be tomorrow and day after tomorrow
             */

            this.startDate = this.timezoneService
              .get()(this.startDate)
              .add(1, "days");
            this.startDateDisplay = this.timezoneService
              .get()(this.startDate)
              .format("MMM Do YYYY");

            this.options.startDate = this.startDate;

            hour = Number(EndOfHourByDay.split([":"])[0]);
            minutes = Number(EndOfHourByDay.split([":"])[1]);
            this.endDate = this.timezoneService
              .get()(this.endDate)
              .add(2, "days")
              .set({ hours: hour })
              .set({ minutes });
            this.endDateDisplay = this.timezoneService
              .get()(this.endDate)
              .format("MMM Do YYYY");
            this.options.endDate = this.endDate;

            // this.ClosingDay = "Next Day"
          } else {
            /**
             * Current time is within restaurant hours
             * Date set would be today and tomorrow
             */

            hour = Number(EndOfHourByDay.split([":"])[0]);
            minutes = Number(EndOfHourByDay.split([":"])[1]);
            this.endDate = this.timezoneService
              .get()(this.endDate)
              .add(1, "days")
              .set({ hours: hour })
              .set({ minutes });
            this.endDateDisplay = this.timezoneService
              .get()(this.endDate)
              .format("MMM Do YYYY");
            this.options.endDate = this.endDate;

            // this.ClosingDay = "Next Day"
          }
          this.setTimes(startHour, startMinutes, hour, minutes);
          if (this.ClosingDay === "Same Day") {
            hour = Number(EndOfHourByDay.split([":"])[0]);
            minutes = Number(EndOfHourByDay.split([":"])[1]);
            this.endDate = this.timezoneService
              .get()(this.startDate)
              .add(0, "days")
              .set({ hours: hour })
              .set({ minutes });
            this.options.endDate = this.options.startDate;
            this.endDateDisplay = this.timezoneService
              .get()(this.options.endDate)
              .format("MMM Do YYYY");
          }
        }
        this.loadPage();
      },
      (error) => {
        const message = this.ApiService.errorMessage(error);
        this.toastr.error(message);
      }
    );
  }

  setTimes(
    startHour: number,
    startMinutes: number,
    endHour: number,
    endMinutes: number
  ) {
    this.dateTimeArray = [];

    startHour = 0;
    startMinutes = 0;
    endHour = 23;
    endMinutes = 60;

    for (let time = 0; time <= 23; time++) {
      let dateTime = this.timezoneService.get()().startOf("day");
      if (time >= startHour && time <= endHour) {
        dateTime.add(time, "hour");
        this.dateTimeArray.push({
          id: time.toString(),
          text: time <= 9 ? `0${time}:00` : `${time}:00`,
        });
        if (time + 1 > endHour) {
          // if (30 <= endMinutes) {
          //     this.dateTimeArray.push({ id: `${time}.5`, text: time <= 9 ? `0${time}:30` : `${time}:30` });
          //     this.dateTimeArray.push({ id: `${time}.5`, text: time <= 9 ? `0${time}:59` : `${time}:59` });
          //     break;
          // }
          if (60 <= endMinutes) {
            for (let index = 1; index < 59; index++) {
              let minutes = index <= 9 ? `0${index}` : index;
              this.dateTimeArray.push({
                id: `${time}.${index}`,
                text: time <= 9 ? `0${time}:${minutes}` : `${time}:${minutes}`,
              });
            }
            this.dateTimeArray.push({
              id: `${time}.59`,
              text: time <= 9 ? `0${time}:59` : `${time}:59`,
            });
            break;
          }
        }
        if (60 <= endMinutes) {
          for (let index = 1; index <= 59; index++) {
            let minutes = index <= 9 ? `0${index}` : index;
            this.dateTimeArray.push({
              id: `${time}.${index}`,
              text: time <= 9 ? `0${time}:${minutes}` : `${time}:${minutes}`,
            });
          }
        }
        // if (30 <= endMinutes) {
        //     this.dateTimeArray.push({ id: `${time}.5`, text: time <= 9 ? `0${time}:30` : `${time}:30` });
        // }
      }
    }

    //this.startTime = this.dateTimeArray[0].id;
    //this.endTime = this.dateTimeArray[this.dateTimeArray.length - 1].id;
    let timeStart = this.startDate.format("HH:mm");
    let timeEnd = this.endDate.format("HH:mm");
    this.startTimeFormatted = this.startDate.format("HH:mm a");
    this.endTimeFormatted = this.endDate.format("HH:mm a");
    this.startTime = this.dateTimeArray.find((x) => x.text === timeStart).id;
    this.endTime = this.dateTimeArray.find((x) => x.text === timeEnd).id;
  }

  hideDiv() {
    this.boolean = true;
    jQuery("#AllDay").hide(100);
  }

  ShowDiv(element) {
    this.boolean = !element;
    if (element) {
      jQuery("#AllDay").show(100);
    } else {
      jQuery("#AllDay").hide(100);
    }
  }

  changeStartTimeOrder() {
    const hour = Number(this.startTime?.split(["."])[0]) || 0;
    const minutes = this.startTime?.split(["."])[1] || 0;

    this.startTimeFormatted = this.timezoneService
      .get()(this.startDate)
      .startOf("day")
      .add(hour, "hours")
      .add(minutes, "minutes")
      .format("HH:mm a");
    this.startDate = this.timezoneService
      .get()(this.startDate)
      .subtract(0, "days")
      .set({ hours: hour })
      .set({ minutes: minutes });
    console.log("startTime", this.startTimeFormatted, this.startDate);
    this.setTimeStart();
  }

  checkTimeOrder() {
    if (this.startTime !== "" && this.endTime !== "") {
      this.hideDiv();
      this.selectedDate({ start: this.startDate, end: this.endDate });
    }
  }

  changeEndTimeOrder() {
    const hour = Number(this.endTime.split(["."])[0]) || 0;
    const minutes = this.endTime.split(["."])[1] || 0;

    this.endTimeFormatted = this.timezoneService
      .get()(this.endDate)
      .startOf("day")
      .add("hour", hour)
      .add("minutes", minutes)
      .format("HH:mm a");
    //change subtract
    this.endDate = this.timezoneService
      .get()(this.endDate)
      .subtract(0, "days")
      .set({ hours: hour })
      .set({ minutes: minutes });
    console.log("endTime", this.endTimeFormatted, this.endDate, hour, minutes);
    this.setTimeEnd();
    this.checkTimeOrder();
  }

  timeFilter() {
    this.changeStartTimeOrder();
    this.changeEndTimeOrder();
    this.offcanvasService.dismiss("cross click");
  }

  clickCustomizeOption() {
    jQuery("#divSecond").click(() => {
      jQuery("#Second").prop("checked", true);
    });
  }

  sameDayIsChecked() {
    return this.ClosingDay === "Same Day";
  }

  nextDayIsChecked() {
    return this.ClosingDay === "Next Day";
  }

  selectClosingDay($event) {
    this.ClosingDay = $event;
  }

  timeDiasbleValidation() {
    const startHour = Number(this.startTime?.split(["."])[0]) || 0;
    const startMinutes = this.startTime?.split(["."])[1] || 0;
    const time1 = this.timezoneService
      .get()(this.startDate)
      .startOf("day")
      .add(startHour, "hours")
      .add(startMinutes, "minutes")
      .format("HH:mm");

    const endhour = Number(this.endTime.split(["."])[0]) || 0;
    const endMinutes = this.endTime.split(["."])[1] || 0;
    const time2 = this.timezoneService
      .get()(this.endDate)
      .startOf("day")
      .add("hour", endhour)
      .add("minutes", endMinutes)
      .format("HH:mm");
    // const time1 = this.startDate.text;
    // const time2 = this.endDate.text;

    // Parse the time strings to create Date objects
    const date1 = new Date(`1970-01-01T${time1}`);
    const date2 = new Date(`1970-01-01T${time2}`);

    // Compare the dates
    if (date1 < date2) {
      return false;
    } else {
      return true;
    }
  }

  tax = 0;
  total = 0;
  transaction_types = [];
  comps = [];
  covers = 0;
  headerToken = {
    "Content-Type": "application/json",
    Authorization: this.cookieService.get("token"),
  };
  params: any = new HttpParams();
  value: string;
  storeId: any = this.cookieService.get("storeId");
  merchantId: any = this.cookieService.get("merchantId");

  resultTypes = [];
  users = [];

  async loadPage() {
    await this.fetchRerport(
      this.timezoneService.get()(this.startDate).format("X"),
      this.timezoneService.get()(this.endDate).format("X")
    );
  }

  revenueCenters: any = [];
  httpOptions = {};
  offset4: any = 0;
  totalRevenueCenter: any = 0;

  getNumberCountRevenueCenter() {
    this.revenueCenters = [];
    return this.http
      .get(this.GLOBALURL + "/revenueCenter", this.httpOptions)
      .subscribe(
        (response: any) => {
          if (response.success == 0) {
            this.toastr.error(response.message);
          } else {
            response.response.forEach((element) => {
              this.revenueCenters.push(element);
            });
            this.totalRevenueCenter = response.total;
            this.offset4 = 100;
            const params = this.params.set("offset", this.offset);
            this.httpOptions3 = {
              headers: new HttpHeaders(this.headerToken),
              params: params,
            };
            if (this.selectedRolesIds != "-" || this.selectedRolesIds != "*") {
              this.getData();
            } else {
              this.newBiggerRevenueCenters = [];
              this.general = {
                types: [],
                total: 0,
                tips: 0,
                quantity: 0,
                countTips: 0,
                refunds: [],
                employees: [],
              };
            }
          }
        },
        (error) => {
          const message = this.ApiService.errorMessage(error);
          this.toastr.error(message);
        }
      );
  }

  getRevenueCenterFunction() {
    for (
      this.offset4;
      this.offset4 < this.totalRevenueCenter;
      this.offset4 += 100
    ) {
      const params = this.params.set("offset", this.offset);
      this.httpOptions3 = {
        headers: new HttpHeaders(this.headerToken),
        params: params,
      };
      this.http
        .get(this.GLOBALURL + "/revenueCenter", this.httpOptions3)
        .subscribe(
          (response: any) => {
            if (response.success == 0) {
              this.toastr.error(response.message);
            } else {
              response.response.forEach((element) => {
                this.revenueCenters.push(element);
              });
            }
          },
          (error) => {
            const message = this.ApiService.errorMessage(error);
            this.toastr.error(message);
          }
        );
    }
  }

  httpOptions3: any = {};
  offset: any = 0;

  apply_conditions(parameters) {
    if (this.selectedLocation != "*") {
      parameters["storeLocationId"] = this.selectedLocation;
    }
    if (this.selectedRolesIds != "*" && this.selectedRolesIds != "-") {
      parameters["roles"] = this.selectedRolesIds;
    }
    return parameters;
  }

  generalPayOuts = [];
  generalPayIns = [];

  general = {
    types: [],
    total: 0,
    tips: 0,
    quantity: 0,
    countTips: 0,
    refunds: [],
    employees: [],
  };
  refundsByEmployee = [];

  async getData() {
    //
    this.newBiggerRevenueCenters = [];
    this.general = {
      types: [],
      total: 0,
      tips: 0,
      quantity: 0,
      countTips: 0,
      refunds: [],
      employees: [],
    };
    const requests = [];
    const gte =
      this.timezoneService.get()(this.startDate).startOf("day").unix() * 1000;
    const lte =
      this.timezoneService.get()(this.endDate).endOf("day").unix() * 1000;
    const firstDate = this.timezoneService
      .get()(this.startDate)
      .format("YYYY/MM/DD");
    const lastDate = this.timezoneService
      .get()(this.endDate)
      .format("YYYY/MM/DD");
    let sameDay = firstDate == lastDate ? true : false;
    let parameters = { gte: gte, lte: lte, sameDay: sameDay };
    parameters = this.apply_conditions(parameters);
    const revenueCenters = this.revenueCenters;
    const roles = this.roles;
    let all;
    // HARDCODED
    sameDay = false;
    if (!sameDay) {
      console.log("Parameters", parameters);
      const result = await this.main.cashoutreport(
        parameters,
        this.cookieService
      );
      this.users = result["response"]["users"];
      all = result["response"]["byuserandall"];
      all[all.length - 1].aggregations.employees.buckets.forEach((element) => {
        this.refundsByEmployee.push({
          reason: element.key,
          refunds: element.refunds.name.buckets,
        });
      });
      // A2 A todos les ponemos sus transactions quantity
      for (let index = 0; index < this.users.length; index++) {
        console.log(all[index * 3]);
        //singara update 25/10: agregue los if porque hay algunos registros en ese for que no tienen bucket, sino reason y se cae todo
        if (
          all[index * 3] !== undefined &&
          all[index * 3].aggregations.revenueCenter !== undefined
        ) {
          all[index * 3].aggregations.revenueCenter.buckets.forEach((group) => {
            if (group.transactionsTotals.buckets !== undefined) {
              group.transactionsTotals.buckets.forEach((d) => {
                if (group.paytypes.type.buckets !== undefined) {
                  group.paytypes.type.buckets.forEach((final) => {
                    if (final.name.buckets[0].key !== undefined) {
                      if (d.key === final.name.buckets[0].key) {
                        final["transactions"] = d.transactions.value;
                      }
                    }
                  });
                }
              });
            }
          });
        }
      }

      // A3 Ahora recorremos todos los revenue Centers para trabajar respectivamente allí
      roles.forEach((role) => {
        const usersCopy = JSON.parse(JSON.stringify(this.users));
        const selectedUsers = [];
        usersCopy.forEach((user, i1) => {
          if (user?.employeeRoleId !== role?.roleId) {
            return;
          }
          let band = false;
          //singara update 25/10: agregue los if porque hay algunos registros en ese for que no tienen bucket, sino reason y se cae todo
          if (
            all[all.length - 2] !== undefined &&
            all[all.length - 2].aggregations.employees !== undefined
          ) {
            all[all.length - 2].aggregations.employees.buckets.forEach(
              (employee) => {
                if (employee.id.buckets[0].key == user.id) {
                  band = true;
                  user["types"] = employee.paytypes.type.buckets;
                  const cashtypes = user["types"].filter((type) => {
                    return type.name.buckets[0].key == "Cash";
                  });
                  if (cashtypes[0] === undefined) {
                    user["types"].push({
                      name: { buckets: [{ key: "Cash" }] },
                      doc_count: 0,
                      total: { value: 0 },
                      tips: { value: 0 },
                    });
                    user["tips"] = 0;
                    user["total"] = 0;
                  }
                  //user["refunds"] = employee.refunds.name.buckets;
                  let totalRefund = 0;
                  let totalQTY = 0;
                  this.refundsByEmployee.forEach((value) => {
                    if (value.reason == user.id) {
                      console.log("user", user.id);
                      user["refunds"] = value.refunds;
                      user["refunds"].forEach((element) => {
                        if (element.key == "QSA") {
                          totalRefund += Math.abs(element.total.value);
                          totalQTY += Math.abs(element.doc_count);
                        }
                      });
                    }
                  });
                  user["refunds"] = [
                    {
                      key: "QSA",
                      doc_count: totalQTY,
                      total: { value: totalRefund },
                    },
                  ];
                  user["total"] = employee.paytypes.total.value + totalRefund;
                  user["tips"] = employee.paytypes.tips.value;
                  user["countTips"] = employee.paytypes.countTips.value;
                  user["quantity"] = employee.paytypes.quantity.value;
                }
              }
            );
          }
          if (band) {
            selectedUsers.push(user);
          }
        });
        role["users"] = selectedUsers;
        role["selected"] = selectedUsers.length > 0 ? true : false;
        this.newBiggerRevenueCenters.push(JSON.parse(JSON.stringify(role)));
        this.roles = [];
      });
    } else {
      // When the days are different
      parameters["process"] = "first";
      const result3: any = await this.main.cashoutreport(
        parameters,
        this.cookieService
      );
      console.log("RESULT3", result3);
      const temp =
        result3.response.byuserandall[11].aggregations.employees.buckets;
      console.log("temp", JSON.parse(JSON.stringify(temp)));
      const employeesIds = result3.response.users.map(function (x) {
        return x.id + "";
      });

      const employeesServersIds = result3.response.users.map(function (x) {
        return x.id + "";
      });

      const intervals = [];

      employeesIds.forEach((employeeId, index) => {
        const intervalsUser = [];
        console.log("temp", JSON.parse(JSON.stringify(temp)));

        temp.forEach((tempSub) => {
          console.log("data search", tempSub, employeeId);
          if (tempSub.key == employeeId) {
            if (tempSub.times.buckets.length) {
              let startInterval = gte;
              const endInterval = lte;
              tempSub.times.buckets.forEach((x) => {
                let one = [];
                one = [startInterval, x.key];
                startInterval = x.key + 1000;
                intervalsUser.push(one);
              });
              intervalsUser.push([startInterval, endInterval]);
            }
          }
        });

        intervals.push({
          employeeId: employeeId + "",
          serverId: employeesServersIds[index],
          intervalos: intervalsUser,
        });
      });
      console.log("intervalsaa", JSON.parse(JSON.stringify(intervals)));
      //intervals = [ { user:"numero1", intervalos:[[0,1],[1,2],[2,3]]}, {user:"numero2", intervalos:[[0,1],[1,2],[2,3]]}, {user:"numero2", intervalos:[]} ]  //Testing sending this to php
      parameters["newIntervals"] = intervals;
      parameters["process"] = "second";

      const resultIntervals = await this.main.cashoutreport(
        parameters,
        this.cookieService
      );
      console.log(resultIntervals);
      // The information
      all = resultIntervals["response"]["alldivided"]
        ? resultIntervals["response"]["alldivided"]
        : resultIntervals["response"]["byuserandall"];
      this.users = result3["response"]["users"];

      //Primero debemos recorrer todo el array otra vez
      const indexArray = (all.length - 3) / 3;
      //console.log(JSON.parse(JSON.stringify(intervals)))
      //The last three are not the ones we want

      // A2
      for (let i = 0; i < indexArray; i++) {
        //console.log(JSON.parse(JSON.stringify(all[i*3])))
        //console.log(JSON.parse(JSON.stringify([i*3])))
        if (all[i * 3].aggregations.revenueCenter !== undefined) {
          all[i * 3].aggregations.revenueCenter.buckets.forEach((group) => {
            group.transactionsTotals.buckets.forEach((d) => {
              group.paytypes.type.buckets.forEach((final) => {
                if (d.key === final.name.buckets[0].key) {
                  final["transactions"] = d.transactions.value;
                }
              });
            });
          });
        }
      }
      console.log(all);

      // A3
      console.log("Here 2");
      console.log("RevenueCenters", revenueCenters);
      console.log("intervals", intervals);
      revenueCenters.forEach((revenueCenter) => {
        const usersCopy = JSON.parse(JSON.stringify(this.users));
        const selectedUsers = [];
        /*console.log(JSON.parse(JSON.stringify("Info")))
console.log(JSON.parse(JSON.stringify(intervals)))
console.log(JSON.parse(JSON.stringify(usersCopy)))*/
        console.log("Entering");

        let index2 = 0;
        for (let index = 0; index < intervals.length; index++) {
          let user = usersCopy[index];

          if (intervals[index].intervalos.length == 0) {
            console.log("First" + index);
            // console.log("Interval evaluated", JSON.parse(JSON.stringify(intervals[index])))
            let band = false;
            console.log(index2 * 3);
            console.log(all[index2 * 3]);
            if (all[index2 * 3] && all[index2 * 3].aggregations.revenueCenter) {
              all[index2 * 3].aggregations.revenueCenter.buckets.forEach(
                (revenue) => {
                  //console.log("Revenue Infor", revenue.key, revenueCenter.revenueCenterId)
                  if (revenue.key == revenueCenter.revenueCenterId) {
                    // console.log("Revenue", index*3, JSON.parse(JSON.stringify(intervals[index]), revenueCenter.revenueCenterId))
                    band = true;
                    user["types"] = revenue.paytypes.type.buckets;
                    const cashtypes = user["types"].filter((type) => {
                      return type.name.buckets[0].key == "Cash";
                    });
                    if (cashtypes[0] === undefined) {
                      user["types"].push({
                        name: { buckets: [{ key: "Cash" }] },
                        doc_count: 0,
                        total: { value: 0 },
                        tips: { value: 0 },
                      });
                      user["tips"] = 0;
                      user["total"] = 0;
                    }
                    //user["refunds"] = revenue.refunds.name.buckets;
                    let totalRefund = 0;
                    let totalQTY = 0;
                    user["refunds"].forEach((element) => {
                      totalRefund += Math.abs(element.total.value);
                      totalQTY += Math.abs(element.doc_count);
                    });

                    user["refunds"] = [
                      {
                        key: "QSA",
                        doc_count: totalQTY,
                        total: { value: totalRefund },
                      },
                    ];
                    user["total"] = revenue.paytypes.total.value + totalRefund;
                    user["tips"] = revenue.paytypes.tips.value;
                    console.log(revenue.paytypes.tips.value);
                    user["quantity"] = revenue.paytypes.quantity.value;
                  }
                }
              );

              const variableNew = all[(index2 + 1) * 3 - 1].aggregations.revenue
                ? all[(index2 + 1) * 3 - 1].aggregations.revenue.buckets
                : [];
              variableNew.forEach((revenuePayin) => {
                const payins = revenuePayin.reason.buckets;
                let result = 0;
                if (
                  revenuePayin.key == revenueCenter.revenueCenterId &&
                  payins.length
                ) {
                  const cashtypes = user["types"]
                    ? user["types"].filter((type) => {
                        return type.name.buckets[0].key == "Cash";
                      })
                    : [undefined];
                  if (cashtypes[0] === undefined) {
                    if (!user["types"]) {
                      user["types"] = [];
                    }
                    user["types"].push({
                      name: { buckets: [{ key: "Cash" }] },
                      doc_count: 0,
                      total: { value: 0 },
                      tips: { value: 0 },
                    });
                    user["tips"] = 0;
                    user["total"] = 0;
                  }
                  user["payins"] = payins;
                  band = true;
                  console.log("payings", payins);
                  user["payins"].forEach((values) => {
                    result = result + values.total.value;
                  });
                  user["types"].forEach((type) => {
                    if (type.name.buckets[0].key == "Cash") {
                      type.total.value += result;
                    }
                  });
                }
              });

              const variableNewSecond = all[(index2 + 1) * 3 - 2].aggregations
                .revenue
                ? all[(index2 + 1) * 3 - 2].aggregations.revenue.buckets
                : [];
              variableNewSecond.forEach((revenuePayout) => {
                let result2 = 0;
                const payouts = revenuePayout.reason.buckets;
                if (
                  revenuePayout.key == revenueCenter.revenueCenterId &&
                  payouts.length
                ) {
                  if (!user["types"]) {
                    user["types"] = [];
                  }
                  const cashtypes = user["types"].filter((type) => {
                    return type.name.buckets[0].key == "Cash";
                  });
                  if (cashtypes[0] === undefined) {
                    user["types"].push({
                      name: { buckets: [{ key: "Cash" }] },
                      doc_count: 0,
                      total: { value: 0 },
                      tips: { value: 0 },
                    });
                    user["tips"] = 0;
                    user["total"] = 0;
                  }
                  user["payouts"] = payouts;
                  band = true;
                  console.log("payouts", payouts);
                  user["payouts"].forEach((values) => {
                    result2 = result2 + values.total.value;
                  });
                  user["types"].forEach((type) => {
                    if (type.name.buckets[0].key == "Cash") {
                      type.total.value -= result2;
                    }
                  });
                }
              });

              if (band) {
                selectedUsers.push(user);
              }
            }
          } else {
            // Now assume you have the revenue center delivered to you
            const originalUser = JSON.parse(JSON.stringify(user));

            for (let j = 0; j < intervals[index].intervalos.length; j++) {
              user = JSON.parse(JSON.stringify(originalUser));
              // console.log("Interval evaluated", JSON.parse(JSON.stringify(intervals[index])))
              let band = false;
              if (
                all[(index2 + j) * 3] &&
                all[(index2 + j) * 3].aggregations.revenueCenter
              ) {
                all[
                  (index2 + j) * 3
                ].aggregations.revenueCenter.buckets.forEach((revenue) => {
                  //console.log("Revenue Infor", revenue.key, revenueCenter.revenueCenterId)
                  if (revenue.key == revenueCenter.revenueCenterId) {
                    // console.log("Revenue", index*3, JSON.parse(JSON.stringify(intervals[index]), revenueCenter.revenueCenterId))
                    band = true;
                    user["types"] = revenue.paytypes.type.buckets;
                    const cashtypes = user["types"].filter((type) => {
                      return type.name.buckets[0].key == "Cash";
                    });
                    if (cashtypes[0] === undefined) {
                      user["types"].push({
                        name: { buckets: [{ key: "Cash" }] },
                        doc_count: 0,
                        total: { value: 0 },
                        tips: { value: 0 },
                      });
                      user["tips"] = 0;
                      user["total"] = 0;
                    }
                    //user["refunds"] = revenue.refunds.name.buckets;
                    let totalRefund = 0;
                    let totalQTY = 0;
                    user["refunds"].forEach((element) => {
                      totalRefund += Math.abs(element.total.value);
                      totalQTY += Math.abs(element.doc_count);
                    });

                    user["refunds"] = [
                      {
                        key: "QSA",
                        doc_count: totalQTY,
                        total: { value: totalRefund },
                      },
                    ];
                    user["total"] = revenue.paytypes.total.value + totalRefund;
                    user["tips"] = revenue.paytypes.tips.value;
                    user["quantity"] = revenue.paytypes.quantity.value;
                  }
                });

                const variableNew = all[(index2 + j + 1) * 3 - 1].aggregations
                  .revenue
                  ? all[(index2 + j + 1) * 3 - 1].aggregations.revenue.buckets
                  : [];
                variableNew.forEach((revenuePayin) => {
                  const payins = revenuePayin.reason.buckets;
                  let result = 0;
                  if (
                    revenuePayin.key == revenueCenter.revenueCenterId &&
                    payins.length > 0
                  ) {
                    const cashtypes = user["types"]
                      ? user["types"].filter((type) => {
                          return type.name.buckets[0].key == "Cash";
                        })
                      : [undefined];
                    if (cashtypes[0] === undefined) {
                      if (!user["types"]) {
                        user["types"] = [];
                      }
                      user["types"].push({
                        name: { buckets: [{ key: "Cash" }] },
                        doc_count: 0,
                        total: { value: 0 },
                        tips: { value: 0 },
                      });
                      user["tips"] = 0;
                      user["total"] = 0;
                    }
                    user["payins"] = payins;
                    band = true;
                    user["payins"].forEach((values) => {
                      result = result + values.total.value;
                    });
                    user["types"].forEach((type) => {
                      if (type.name.buckets[0].key == "Cash") {
                        type.total.value += result;
                      }
                    });
                  }
                });

                const variableNewSecond = all[(index2 + j + 1) * 3 - 2]
                  .aggregations.revenue
                  ? all[(index2 + j + 1) * 3 - 2].aggregations.revenue.buckets
                  : [];
                variableNewSecond.forEach((revenuePayout) => {
                  let result2 = 0;
                  const payouts = revenuePayout.reason.buckets;
                  if (
                    revenuePayout.key == revenueCenter.revenueCenterId &&
                    payouts.length > 0
                  ) {
                    if (!user["types"]) {
                      user["types"] = [];
                    }
                    const cashtypes = user["types"].filter((type) => {
                      return type.name.buckets[0].key == "Cash";
                    });
                    if (cashtypes[0] === undefined) {
                      user["types"].push({
                        name: { buckets: [{ key: "Cash" }] },
                        doc_count: 0,
                        total: { value: 0 },
                        tips: { value: 0 },
                      });
                      user["tips"] = 0;
                      user["total"] = 0;
                    }
                    user["payouts"] = payouts;
                    band = true;
                    user["payouts"].forEach((values) => {
                      result2 = result2 + values.total.value;
                    });
                    user["types"].forEach((type) => {
                      if (type.name.buckets[0].key == "Cash") {
                        type.total.value -= result2;
                      }
                    });
                  }
                });

                if (band) {
                  selectedUsers.push(user);
                }
              }
            }
            index2 = index2 + intervals[index].intervalos.length - 1;
            //console.log("Interval evaluated index", JSON.parse(JSON.stringify([index])))
            //console.log("Interval evaluated", JSON.parse(JSON.stringify(intervals[index])))
            //console.log("Interval evaluated", JSON.parse(JSON.stringify(intervals[index].intervalos.length)))
            //console.log("Last", JSON.parse(JSON.stringify([index])))
          }
          index2++;
        }
        //  console.log("selectedusers", JSON.parse(JSON.stringify(selectedUsers)))
        revenueCenter["users"] = selectedUsers;
        revenueCenter["selected"] = selectedUsers.length > 0 ? true : false;
        this.newBiggerRevenueCenters.push(
          JSON.parse(JSON.stringify(revenueCenter))
        );
        index2++;
      });
    }

    // The total; All Departments
    this.general.types = all[all.length - 2].aggregations.paytypes.type.buckets;
    this.general.employees = all[all.length - 2].aggregations.employees.buckets;
    this.general.refunds = all[all.length - 2].aggregations.employees.buckets;

    let refundstotal = 0;
    let refundsqty = 0;

    all[all.length - 1].aggregations.employees.buckets.forEach((element) => {
      const refunds = element.refunds.name.buckets;
      refunds.forEach((refund) => {
        if (refund.key == "QSA") {
          refundstotal += Math.abs(refund.total.value);
          refundsqty += refund.doc_count;
        }
      });
    });

    this.general.refunds = [
      { key: "QSA", doc_count: refundsqty, total: { value: refundstotal } },
    ];

    const generalcashtypes = this.general.types.filter((type) => {
      return type.name.buckets[0].key == "Cash";
    });
    if (generalcashtypes[0] === undefined) {
      this.general.types.push({
        name: { buckets: [{ key: "Cash" }] },
        doc_count: 0,
        total: { value: 0 },
        tips: { value: 0 },
      });
    }
    this.general.total =
      all[all.length - 2].aggregations.paytypes.total.value + refundstotal;
    this.general.tips = all[all.length - 2].aggregations.paytypes.tips.value;
    this.general.quantity =
      all[all.length - 2].aggregations.paytypes.quantity.value;
    this.general.countTips =
      all[all.length - 2].aggregations.paytypes.countTips.value;
    all[all.length - 2].aggregations.transactionsTotals.buckets.forEach((d) => {
      this.general.types.forEach((final) => {
        if (d.key === final.name.buckets[0].key) {
          final["transactions"] = d.transactions.value;
        }
      });
    });
    let result2 = 0;
    this.generalPayOuts = all[all.length - 4].aggregations.reason.buckets;
    this.generalPayOuts.forEach((values) => {
      result2 = result2 + values.total.value;
    });
    this.general.types.forEach((type) => {
      if (type.name.buckets[0].key == "Cash") {
        type.total.value -= result2;
      }
    });
    result2 = 0;
    this.generalPayIns = all[all.length - 3].aggregations.reason.buckets;
    this.generalPayIns.forEach((values) => {
      result2 = result2 + values.total.value;
    });
    this.general.types.forEach((type) => {
      if (type.name.buckets[0].key == "Cash") {
        type.total.value += result2;
      }
    });
    console.log("this.general.types", this.general.types);
    jQuery(".allpageLoader").css("display", "block");
  }

  roles = [];
  totalRoles = 0;
  offset5 = 0;
  httpOptions4: any = {};

  getRolesFunction() {
    this.httpOptions4 = {
      headers: new HttpHeaders(this.headerToken),
      params: this.params,
    };
    this.http.get(this.GLOBALURL + "/role", this.httpOptions4).subscribe(
      (response: any) => {
        if (response.success == 0) {
          this.toastr.error(response.message);
        } else {
          response.response.forEach((element) => {
            this.roles.push(element);
          });
          console.log("ROLES", this.roles);
        }
      },
      (error) => {
        const message = this.ApiService.errorMessage(error);
        this.toastr.error(message);
      }
    );
  }

  timezone = "";
  httpOptions5: any = {};

  getSettingsFunction() {
    const params = { storeId: this.storeId };
    this.httpOptions5 = {
      headers: new HttpHeaders(this.headerToken),
      params: { ...params, settingName: "Timezone" },
    };
    this.http.get(this.GLOBALURL + "/settings", this.httpOptions5).subscribe(
      (response: any) => {
        if (response.success == 0) {
          this.toastr.error(response.message);
        } else {
          response.response.forEach((element) => {
            this.timezone = element.settingValue;
          });
        }
      },
      (error) => {
        const message = this.ApiService.errorMessage(error);
        this.toastr.error(message);
      }
    );
  }

  Allchecked = true;
  selectedRoles = "All Roles";
  selectedRolesIds: any = "*";
  selectRolesClass = "mselect-wrapper";
  selectRolesListClass = "mselect-dropdown hideoptions";

  toggleRoles() {
    if (this.selectRolesClass == "mselect-wrapper open") {
      this.selectRolesClass = "mselect-wrapper";
      this.selectRolesListClass = "mselect-dropdown hideoptions";
    } else {
      this.selectRolesClass = "mselect-wrapper open";
      this.selectRolesListClass = "mselect-dropdown showoptions";
    }
  }

  closeRoles() {
    this.selectRolesClass = "mselect-wrapper";
    this.selectRolesListClass = "mselect-dropdown hideoptions";
  }

  selectRoles(status_id) {
    console.log(status_id);
    if (status_id == "*") {
      if (this.Allchecked) {
        this.roles.forEach((role) => {
          role.checked = false;
        });
        this.Allchecked = false;
        this.selectedRoles = "None";
        this.selectedRolesIds = "-";
      } else {
        this.roles.forEach((role) => {
          role.checked = true;
        });
        this.Allchecked = true;
        this.selectedRoles = "All Roles";
        this.selectedRolesIds = "*";
      }
    } else {
      const status = this.roles.filter((role) => {
        return role?.roleId == status_id;
      })[0];
      console.log(status);
      if (status.checked) {
        status.checked = false;
        this.Allchecked = false;
      } else {
        status.checked = true;
        if (
          this.roles.filter((role) => {
            return role.checked;
          }).length == this.roles.length
        ) {
          this.Allchecked = true;
          this.selectedRoles = "All Roles";
          this.selectedRolesIds = "*";
        }
      }
      this.selectedRoles = this.roles
        .filter((role) => {
          return role.checked;
        })
        .map((status) => {
          return status.roleName;
        })
        .join(";");
      this.selectedRolesIds = this.roles
        .filter((role) => {
          return role.checked;
        })
        .map((status) => {
          return status?.roleId;
        });
      if (
        this.roles.filter((role) => {
          return !role.checked;
        }).length == this.roles.length
      ) {
        this.selectedRoles = "None";
        this.selectedRolesIds = "-";
      }
    }
    const ids = this.roles
      .filter((role) => {
        return role.checked;
      })
      .map((status) => {
        return status?.roleId;
      });
    console.log("selectedRolesIds", this.selectedRolesIds);
    if (this.selectedRolesIds != "-") {
      this.loadPage();
    } else {
      console.log("entre?");
      this.newBiggerRevenueCenters = [];
      this.general = {
        types: [],
        total: 0,
        tips: 0,
        quantity: 0,
        countTips: 0,
        refunds: [],
        employees: [],
      };
    }
  }

  changeShift(value: any) {
    this.selectedShift = value;
  }

  // tslint:disable-next-line:member-ordering
  headerTokenDetails = {
    "Content-Type": "application/json",
    Authorization: this.cookieService.get("token"),
  };
  httpOptions1 = { headers: new HttpHeaders(this.headerTokenDetails) };
  headerTokenDoc = { Authorization: this.cookieService.get("token") };
  // tslint:disable-next-line:member-ordering
  selectedShift = "all";
  data: any = [];
  employees: any = [];
  employeesWithMail: any = [];
  employeeId: any = [];
  revenueCenterId: any = [];
  isOpen: boolean = false;
  isOpenRenueve: boolean = false;
  isOpenTips: boolean = false;
  revenues: any = [];
  emptydata: boolean = true;
  tipout: boolean = true;
  isOpenEmployeesReport: boolean = false;
  listOfPeople: any = [];

  getEmployeesbyStoreID = (employess) => {
    if (this.storeId === "*") {
      return employess.response.filter((employee) => {
        return employee.status != 0;
      });
    }
    return employess.response.filter((employee) => {
      return employee.storeId === this.storeId && employee.status != 0;
    });
  };
  getEmployeesbyStoreIDWithMail = (employess) => {
    if (this.storeId === "*") {
      return employess.response;
    }
    return employess.response.filter((employee) => {
      return (
        employee.storeId === this.storeId &&
        employee.status === 1 &&
        employee.employeeEmail !== ""
      );
    });
  };

  fetchEmployee = async () => {
    this.store.dispatch(setLoadingSpinner({ status: true }));
    await this.http
      .get(this.GLOBALURL + "/employee", this.httpOptions2)
      .subscribe((response: any) => {
        // this.store.dispatch(setLoadingSpinner({ status: false }));
        this.employees = this.getEmployeesbyStoreID(response);
        this.employeesWithMail = this.getEmployeesbyStoreIDWithMail(response);
        this.listOfemployees = this.employees.map((person, i) => {
          return (this.listOfPeople[i] = {
            id: person.employeeId,
            name: person?.employeeFirstName + " " + person?.employeeLastName,
          });
        });
        this.EmployeefilteredData = this.listOfemployees;
      }),
      (error: any) => {
        this.store.dispatch(setLoadingSpinner({ status: false }));
        if (error.status === 401) {
          // Handle 401 Unauthorized error
          console.log("Unauthorized error");
        } else {
          // Handle other errors
          console.log("Error:", error);
          // Perform necessary error handling
        }
      };
  };

  fetchRevenue = async () => {
    await this.http
      .get(
        this.GLOBALURL + "/revenueCenter?storeId=" + this.storeId,
        this.httpOptions1
      )
      .subscribe(
        (response: any) => {
          this.revenues = response.response;
        },
        (error: any) => {
          if (error.status === 401) {
            console.log("Unauthorized error");
          } else {
            console.log("Error:", error);
          }
        }
      );
  };

  fetchRerport = async (start, end) => {
    this.store.dispatch(setLoadingSpinner({ status: true }));
    const params = {
      reportName: "payroll_report",
      query: {
        page: this.page,
        employeeIds: this.employeeId,
        items: parseInt(this.itemsPP, 10),
        startDate: parseInt(start, 10),
        endDate: parseInt(end, 10),
        showTips: this.tipout,
        offset: 0,
        storeId: this.storeId,
      },
    };

    if (this.notWholeDay()) {
      params.query["startTime"] = this.timeStart;
      params.query["endTime"] = this.timeEnd;
    }

    await this.http
      .post(this.GLOBALURL + "/reports/query", params, this.httpOptions1)
      .subscribe(
        (response: any) => {
          if (response.results === 0) {
            this.emptydata = true;
            console.log("RESPONSE 00");
          } else {
            this.data = response?.data;
            this.totalElements = response?.meta?.pages * this.itemsPP;
            this.emptydata = false;
            this.calculateTotalHours();
          }
          this.store.dispatch(setLoadingSpinner({ status: false }));
        },
        (error) => {
          console.log("RESPONSE 00--ERRORR");
          this.store.dispatch(setLoadingSpinner({ status: false }));
        }
      );
  };
  notWholeDay() {
    return (
      (this.timeStart !== "00:00" && this.timeEnd === "23:59") ||
      (this.timeEnd !== "23:59" && this.timeStart === "00:00") ||
      (this.timeStart !== "00:00" && this.timeEnd !== "23:59")
    )
  }
  ShowExport: boolean = false;
  calculateTotalHours() {
    this.totalTime = '';
    this.data?.forEach((employee,index) => {
      employee.total.regular = '0h 0m';
      employee.workingHours.forEach((subtotal) => {
        let time1 = this.calculateTimeDifference(
          subtotal.clockIn,
          subtotal.clockOut
        );
    const time2 = employee.total.regular;  // Replace with your actual time

    // Parse the hours and minutes from the time strings
    const [hours1, minutes1] = time1.split('h ').map(x => parseInt(x));
    const [hours2, minutes2] = time2.split('h ').map(x => parseInt(x));

    // Convert everything to minutes
    const totalMinutes1 = hours1 * 60 + minutes1;
    const totalMinutes2 = hours2 * 60 + minutes2;

    // Add the minutes together
    let totalMinutes = totalMinutes1 + totalMinutes2;

    // Convert back to hours and minutes
    const totalHours = Math.floor(totalMinutes / 60);
    totalMinutes %= 60;

    // Format the total time as a string
    this.data[index].total.regular = `${totalHours}h ${totalMinutes}m`;

      });
      console.log('employee.subtotals[0].regular',this.data[index].total.regular);
    });
  }
  calculateTimeDifference(clockIn: string, clockOut: string): string {
    const format = 'hh:mm:ss A';
    const clockInMoment = moment(clockIn, format);
    const clockOutMoment = moment(clockOut, format);

    if (clockOutMoment.isBefore(clockInMoment)) {
      clockOutMoment.add(1, 'day');
    }

    const diff = moment.duration(clockOutMoment.diff(clockInMoment));
    const diffInHoursAndMinutes = `${Math.floor(diff.asHours())}h ${diff.minutes()}m`;
    return diffInHoursAndMinutes;
  }

  formatRegularSubTotal(value) {
    // the value is in this format '7.07' I want to convert it to '7h 7m'
    const [hours, minutes] = value ? value.split('.') : [0, 0];
    return `${hours}h ${minutes}m`;
  }

  totalTime: string = '';

  getAllId = () => {
    return this.employees.map((employee) => {
      return employee.employeeId;
    });
  };

  getAllRevenueId = () => {
    return this.revenues.map((revenue) => {
      return revenue.revenueCenterId;
    });
  };
  searchTerm: string = "";
  EmployeefilteredData: any;
  ishown: boolean = false;
  AllDetails: boolean = false;
  ischeked: boolean = false;
  isAllChecked: boolean;
  onCrossButtonClick() {
    this.EmployeefilteredData = this.listOfemployees;
    this.searchTerm = "";
    this.ishown = false;
  }
  onSearch() {
    this.EmployeefilteredData = this.listOfemployees.filter((item) =>
      item.name.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
    this.ishown = this.EmployeefilteredData.length === 0;
  }
  addnewEmployeeFilter = (employeeIds) => {
    this.offcanvasService.dismiss("cross click");
    console.log(employeeIds);
    var dataId = employeeIds;

    let employeeExist: any = [];
    const employeeNumber = this.employees.length;
    const employeeChecked = this.employeeId.length;
    if (employeeIds === "all") {
      this.employeeId =
        this.employeeId.length === 0 ? this.getAllId() : this.getAllId();
      this.isAllChecked = !this.isAllChecked;
      if (!this.isAllChecked || employeeNumber === employeeChecked) {
        this.employeeId = [];
      }
    } else {
      employeeExist = this.employeeId.find((employee) => {
        return employee === dataId.id;
      });

      if (employeeExist === undefined) {
        this.employeeId.push(dataId.id);
      } else {
        this.employeeId = this.employeeId.filter((employee) => {
          return employee !== dataId.id;
        });
      }
      this.ischeked = this.EmployeefilteredData.every(
        (item: any) => this.AllDetails[item.id]
      );
    }
    this.isAllEmployeesChecked();
    this.loadPage();
  };
  isAllEmployeesChecked = () => {
    const employeeNumber = this.employees.length;
    const employeeChecked = this.employeeId.length;
    return (this.isAllChecked = employeeChecked === employeeNumber);
  };
  addEmployeeFilter = (employeeId, select) => {
    let employeeExist: any = [];
    const employeeNumber = this.employees.length;
    const employeeChecked = this.employeeId.length;
    if (select) {
      if (employeeId === "all") {
        this.employeeId =
          this.employeeId.length === 0 ? this.getAllId() : this.getAllId();
      } else {
        employeeExist = this.employeeId.find((employee) => {
          return employee === employeeId;
        });

        if (employeeExist === undefined) {
          this.employeeId.push(employeeId);
        } else {
          this.employeeId = this.employeeId.filter((employee) => {
            return employee !== employeeId;
          });
        }
      }
    } else {
      if (employeeId == "all") {
        this.employeeId = [];
      }
      const index = this.employeeId.indexOf(employeeId);
      if (index > -1) {
        // only splice array when item is found
        this.employeeId.splice(index, 1); // 2nd parameter means remove one item only
      }
    }
    this.loadPage();
  };
  findEmployeeCheck = (paymentMethodId) => {
    const paymentCheck = this.employeeId.filter((x) => x === paymentMethodId);
    return paymentCheck.length > 0 ? true : false;
  };
  addRevenueFilter = (revenueId, select) => {
    let revenueExist: any = [];
    const revenueNumber = this.revenues.length;
    const revenueChecked = this.revenueCenterId.length;
    if (select) {
      if (revenueId === "all") {
        this.revenueCenterId =
          this.revenueCenterId.length === 0
            ? this.getAllRevenueId()
            : this.getAllRevenueId();
      } else {
        revenueExist = this.revenueCenterId.find((revenue) => {
          return revenue === revenueId;
        });

        if (revenueExist === undefined) {
          this.revenueCenterId.push(revenueId);
        } else {
          this.revenueCenterId = this.revenueCenterId.filter((re) => {
            return re !== revenueId;
          });
        }
      }
    } else {
      if (revenueId == "all") {
        this.revenueCenterId = [];
      }

      const index = this.revenueCenterId.indexOf(revenueId);
      if (index > -1) {
        // only splice array when item is found
        this.revenueCenterId.splice(index, 1); // 2nd parameter means remove one item only
      }
    }

    this.loadPage();
  };

  p: number = 1;

  onLimitSelected(e) {
    this.itemsPP = e;
    this.loadPage();
  }

  tipoutSelected = (tipout) => {
    return tipout ? "Tipout" : "No Tipout";
  };

  sendEmail = () => {
    this.submitEmail = true;
    const emailData = this.emailForm.value;
    if (emailData.email) {
      const params = {
        email: emailData.email,
        emailCC: emailData.emailCC,
        userFullName: "",
        reportName: "payroll_report",
        query: {
          page: 1,
          item: 2,
          // tipout: this.tipout,
          showTips: this.tipout,
          startDate: parseInt(
            this.timezoneService.get()(this.startDate).format("X"),
            10
          ),
          endDate: parseInt(
            this.timezoneService.get()(this.endDate).format("X"),
            10
          ),
          employeeIds: this.employeeId,
          revenueCenterId: this.revenueCenterId,
          offset: 0,
          storeId: this.storeId,
        },
      };

      if (this.notWholeDay()) {
        params.query["startTime"] = this.timeStart;
        params.query["endTime"] = this.timeEnd;
      }
      this.http
        .post(this.GLOBALURL + "/reports/send", params, this.httpOptions1)
        .subscribe(
          (response: any) => {
            if (response.error === true) {
            } else {
              this.toastr.success(response.message);
            }
            this.emailForm?.reset();

          },
          (error) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            this.emailForm?.reset();

          }
        );
    }

    // send mail hide 10
  };

  donwloadFile = (file) => {
    this.closefilter();
    let startDate = this.timezoneService.get()(this.startDate);
    let endDate = this.timezoneService.get()(this.endDate);
    const params = {
      reportName: "payroll_report",
      format: file,
      query: {
        service: "all",
        employeeIds: this.employeeId,
        revenueCenterId: this.revenueCenterId,
        // tipout: this.tipout,
        showTips: this.tipout,
        startDate: this.timezoneService.get()(startDate).format("X"),
        endDate: this.timezoneService.get()(endDate).format("X"),
        offset: 0,
        storeId: this.storeId,
      },
    };

    if (this.notWholeDay()) {
      params.query["startTime"] = this.timeStart;
      params.query["endTime"] = this.timeEnd;
    }

    this.http
      .post(this.GLOBALURL + "/reports/export", params, this.httpOptions1)
      .subscribe(
        (response: any) => {
          if (response.error === true) {
            this.toastr.error(response.message);
          } else {
            this.toastr.info(response.message);
            let headers = new HttpHeaders();
            headers = headers.set("Accept", "application/pdf");
            if (response.data && response.data?.url) {
              this.http
              .get(response.data.url, {
                headers: headers,
                responseType: "blob",
              })
              .subscribe((blob: Blob): void => {
                var blob = new Blob([blob], {
                  type: response.data.contentType,
                });
                var url = window.URL.createObjectURL(blob);
                var anchor = document.createElement("a");
                anchor.download = response.data.name;
                anchor.href = url;
                anchor.click();
                this.toastr.success("File exported");
              });
            }
          }
        },
        (error) => {
          this.store.dispatch(setLoadingSpinner({ status: false }));
        }
      );
  };

  // tslint:disable-next-line:member-ordering
  subscribes: any = [];
  // tslint:disable-next-line:member-ordering
  allSubscribe: boolean = false;
  // tslint:disable-next-line:member-ordering
  all: boolean = false;

  selectAllSubscribe = (select) => {
    if (select) {
      this.employees.forEach(
        (employee) => (employee.reportSubscription.cashouts = true)
      );
      this.subscribes = this.employees.map((o) => o.employeeId);
      this.employeeError = false;
      // this.subscribes = this.employees;
    } else {
      this.employees.forEach(
        (employee) => (employee.reportSubscription.cashouts = false)
      );
    }
  };

  createSubscribe = (employeeId, select) => {
    this.all = false;
    if (select) {
      this.subscribes.push(employeeId);
      this.employeeError = false;
    } else {
      this.subscribes.pop(employeeId);
    }
  };
  cancel() {
    // this.modalService.dismissAll();
    this.subscribeEmailModal.close();
    this.employeeError = false;
  }

  cancel2() {
    // this.modalService.dismissAll();
    this.scheduleEmailModal.close();
    this.scheduleEmployee = []
        this.frequency = ""
    this.employeeError = false;
  }

  checkTimeValidation(value) {
    console.log("this.frequency", this.frequency)
    if (!value && this.frequency?.length == 0) {
      this.frequencyErr = true;
      console.log('Schedule Time is invalid!');
      // return;
    } else {
      this.frequencyErr = false;
    }
  }

  checkTimeValidationDeSelectAll(value) {
    console.log("this.frequency", this.frequency)
    if (!value) {
      this.frequencyErr = true;
      console.log('Schedule Time is invalid!');
      // return;
    }
  }

  frequencyErr = false
  scheduleReport= () => {
    let employees = [];

    console.log("his.scheduleEmployee", this.scheduleEmployee)
    console.log("his.frequency", this.frequency)
    if (!this.scheduleEmployee) {
      this.employeeError = true;
      console.log('Schedule Employee is invalid!');
      return;
    }
    if (this.scheduleEmployee && this.scheduleEmployee?.length == 0) {
      this.employeeError = true;
      console.log('Schedule Employee is invalid!');
      return;
    }
    if (!this.frequency || this.frequency?.length == 0) {
      this.frequencyErr = true;
      console.log('Schedule Time is invalid!');
      return;
    }
    this.store.dispatch(setLoadingSpinner({ status: true }));
    this.frequencyErr = false

    // this.subscribes.map((emp) => {
    //   let employee = this.employees.find((subscribe) => {
    //     return subscribe.employeeId === emp;
    //   });

      const payload = {
        employeeIds: this.scheduleEmployee.map(employee => employee.id),
        reportName: "payroll_report",
        frequency:  this.frequency.map((id) => id.value),
        storeId: this.storeId,
        merchantId: this.merchantId,
      };

      // employees.push(params);
    // });


    this.http
      .post(
        this.GLOBALURL + "/schedules/report", payload, this.httpOptions1
      )
      .subscribe((response: any) => {
        if(response.success == 0) {
          this.cancel2();
        // this.subscribes = []
        // this.isOpenToggleEmployee = false;
        this.scheduleEmployee = []
        this.frequency = ""
        this.store.dispatch(setLoadingSpinner({ status: false }));
        this.toastr.success(response.message);
        } else {
          this.cancel2();
        // this.subscribes = []
        // this.isOpenToggleEmployee = false;
        this.scheduleEmployee = []
        this.frequency = ""
        this.store.dispatch(setLoadingSpinner({ status: false }));
        this.toastr.success(response.message);
        }
      }, (error) => {
        this.cancel2();
        // this.subscribes = []
        // this.isOpenToggleEmployee = false;
        this.scheduleEmployee = []
        this.frequency = ""
        this.store.dispatch(setLoadingSpinner({ status: false }));
        const message = this.ApiService.errorMessage(error);
        this.toastr.error(message);
      });

    // this.isOpenToggleEmployee = false;
    // this.subscribes = [];
    // this.store.dispatch(setLoadingSpinner({ status: false }));
    // this.fetchEmployee();
  };

  subscribeEmployees = () => {
    // sub mail hide 10

    let employees = [];
    if (this.multiselectControl.invalid) {
      this.employeeError = true;
      console.log('Multiselect control is invalid!');
      return;
    }
    if (this.subForm.invalid) {
      this.employeeError = true;
      console.log('SubForm is invalid!');
      return;
    }
    this.subscribes.map((emp) => {
      let employee = this.employees.find((subscribe) => {
        return subscribe.employeeId === emp;
      });

      const params = {
        employeeId: employee.employeeId,
        reportSubscription: {
          gross: employee.reportSubscription.gross,
          shift: employee.reportSubscription.shift,
          detailed: employee.reportSubscription.detailed,
          refunds: employee.reportSubscription.refunds,
          today: employee.reportSubscription.today,
          daily: employee.reportSubscription.daily,
          payroll: true,
          discounts: employee.reportSubscription.discounts,
          cashouts: employee.reportSubscription.cashouts,
        },
      };

      employees.push(params);
    });

    this.http
      .put(
        this.GLOBALURL + "/employee/subscription",
        { employees },
        this.httpOptions1
      )
      .subscribe((response: any) => {
        this.cancel();
        this.store.dispatch(setLoadingSpinner({ status: false }));
        this.toastr.success(response.message);
      });

    this.subscribes = [];
    this.fetchEmployee();
  };
  Newselecttip = [
    { value: true, name: "Tipout" },
    { value: false, name: "No Tipout" },
  ];
  ChnageSelectTip(value:boolean) {
    this.isOpenTips = false;
    this.tipout = value;
    // this.tipout = value == "true" ? true : false;
    this.offcanvasService.dismiss("cross click");
    this.loadPage();
  }
  changeTip = (value) => {
    this.isOpenTips = false;
    this.tipout = value == "true" ? true : false;
    this.loadPage();
  };

  updatePage = (event) => {
    this.p = event;
    this.loadPage();
  };

  // changeTimeZoneStore(date) {
  //   let time = new Date(date);
  //   let timeConvert = this.convertTZ(time, this.timeZone);
  //   return moment(timeConvert);
  // }

  // convertTZ(date, tzString) {
  //   return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: tzString }));
  // }
  closefilter() {
    this.offcanvasService.dismiss("cross click");
    this.OpenDetails = "mainMenu";
  }

  openModalSubscribe(content) {
    this.closefilter();

    this.subscribeEmailModal = this.modalService.open(content, { centered: true, backdrop: "static" });
    this.subscribeEmailModal
      .result.then((result) => {
        if (result === "subsribe") {
          this.subscribeEmployees();
          console.log(result);
        }
      });
  }

  scheduleEmailModal: NgbModalRef;
  openModalSchedule(content) {
    this.employeeError = false;
    this.frequencyErr = false;
    this.offcanvasService.dismiss("cross click");
    this.OpenDetails = "mainMenu";
    this.scheduleEmailModal = this.modalService
      .open(content, { centered: true, backdrop: "static" })

    this.scheduleEmailModal
      .result.then((result) => {
        if (result === "subsribe") {
          // this.subscribeEmployees();
          console.log(result);
        }
      });
  }

  openModalEmail(emailModal) {
    this.closefilter();

    this.modalService
      .open(emailModal, { centered: true, backdrop: "static" })
      .result.then((result) => {
        if (result === "Send") {
          this.sendEmail();
          console.log(result);
        }
      });
  }
  OpenDetails = "mainMenu";
  OpenFilterCanva(content1: TemplateRef<any>) {
    this.offcanvasService.open(content1, { position: "end" });

    const t1 = document.getElementsByClassName("Filter-Canvas-open");

    if (t1.length > 0) {
      const firstElement = t1[0];

      firstElement.classList.remove("cashout-filter");

      console.log("Class removed from the element", firstElement);
    } else {
      console.log("No element found with the specified class");
    }
  }
  isDropdownOpen = false;
  isDropdownOpen1 = false;
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  setDateTexts() {
    setTimeout(() => {
      let ranges = document.querySelectorAll(".ranges li");
      let $ranges = this.createTranslateArr(ranges);

      let months = document.querySelectorAll(".table-condensed .month");
      let $months = this.createTranslateArr(months);

      let buttons = document.querySelectorAll(".drp-buttons .btn");
      let $buttons = this.createTranslateArr(buttons);

      // let days = document.querySelectorAll(".table-condensed thead tr");
      // let first = days[1].querySelectorAll("th");
      // let second = days[3].querySelectorAll("th");
      // let $first = this.createTranslateArr(first);
      // let $second = this.createTranslateArr(second);

      // this.translateArrayOfTexts($first, first);
      this.translateArrayOfTexts($buttons, buttons);
      this.translateArrayOfTexts($ranges, ranges);
      this.translateArrayOfTexts($months, months)

    }, 1);

  }

  createTranslateArr(arr: any) {
    let newArr = [];
    arr.forEach((item) => {
      if (item && typeof item.textContent === 'string') {
        newArr.push(this.translatePipe.transform(item.textContent));
      }
    });
    return newArr;
  }

  translateArrayOfTexts($arrToTranslate: string[], arrOfElements: any) {
    if ($arrToTranslate.length === 0) return;

    forkJoin($arrToTranslate)
      .subscribe(texts => {
        texts.forEach((text, i) => {
          arrOfElements[i].textContent = text;
        });
      },
      (error) => {
        console.error("Error in translating:", error);
      })
  }
}
